import PlayerRegistrationStep from './step';
import constants from './constants';

export default class PlayerRegistrationStep2 extends PlayerRegistrationStep {
    constructor(...args) {
        super(...args);

        this.onPgaTourSelectChange = this.onPgaTourSelectChange.bind(this);
        this.onFinalVenuesChange = this.onFinalVenuesChange.bind(this);
        this.onRqCourseChange = this.onRqCourseChange.bind(this);
    }

    static getRequiredRefs() {
        return [
            'isExemptSection',
            'isNotExemptSection',
            'needFinal',
            'needRegional',
            'pgaTourSection',
            'pgaTourWithExemption',
            'pgaTourWithoutExemption',
            'pgaTourWithExemptionPlaceholder',
            'pgaTourWithoutExemptionPlaceholder',
            'pgaTourSelect',
            'pgaTourOther',
            'finalVenues'
        ];
    }

    initConcrete() {
        this.refs.pgaTourOther.style.display = 'none';
        this.refs.pgaTourSection.style.display = 'none';
        this.pgaOtherValue = this.getAttribute(this.refs.pgaTourSelect, 'other-value');
        if (!this.pgaOtherValue) {
            throw new Error('Other value for PGA or Tout is not specified');
        }
        this.addListenersConcrete();
    }

    addListenersConcrete() {
        this.refs.pgaTourSelect.addEventListener('change', this.onPgaTourSelectChange);
        this.refs.finalVenues.forEach((radio) => radio.addEventListener('change', this.onFinalVenuesChange));
        if (this.refs.rqCourseSelect && this.refs.rqCourseSelect.length) {
            this.refs.rqCourseSelect.forEach((select) => select.addEventListener('change', this.onRqCourseChange));
        }
    }

    applyStateConcrete({ exemption }) {
        if (this.exemption !== exemption) {
            this.applyExemption(exemption);
        }
    }

    applyExemption(exemption) {
        this.exemption = exemption;
        switch (this.exemption) {
            case constants.EXEMPTION_YES:
                this.refs.isExemptSection.style.display = 'block';
                this.refs.isNotExemptSection.style.display = 'none';
                this.showPgaTourSection(true);
                break;
            case constants.EXEMPTION_FINAL:
            case constants.EXEMPTION_NO:
                this.refs.isExemptSection.style.display = 'none';
                this.refs.isNotExemptSection.style.display = 'block';
                this.applyRegionalFinalVisibility(this.exemption);
                this.showPgaTourSection(false);
                break;
            default:
        }
    }

    applyRegionalFinalVisibility(exemption) {
        switch (exemption) {
            case constants.EXEMPTION_FINAL:
                if (this.refs.needRegional.length > 0) {
                    this.refs.needRegional.forEach((node) => {
                        node.style.display = 'none';
                    });
                }
                if (this.refs.needFinal.length > 0) {
                    this.refs.needFinal.forEach((node) => {
                        node.style.display = 'block';
                    });
                }
                break;
            case constants.EXEMPTION_NO:
                if (this.refs.needRegional.length > 0) {
                    this.refs.needRegional.forEach((node) => {
                        node.style.display = 'block';
                    });
                }
                if (this.refs.needFinal.length > 0) {
                    this.refs.needFinal.forEach((node) => {
                        node.style.display = 'none';
                    });
                }
                break;
            default:
        }
    }

    showPgaTourSection(withExemption) {
        this.refs.pgaTourSection.style.display = 'block';
        if (withExemption) {
            this.refs.pgaTourWithExemption.forEach((node) => {
                node.style.display = 'block';
            });
            this.refs.pgaTourWithoutExemption.forEach((node) => {
                node.style.display = 'none';
            });
            this.refs.pgaTourWithExemptionPlaceholder.insertAdjacentElement('beforeEnd', this.refs.pgaTourSection);
            this.refs.pgaTourSelect.removeAttribute('required');
        } else {
            this.refs.pgaTourWithExemption.forEach((node) => {
                node.style.display = 'none';
            });
            this.refs.pgaTourWithoutExemption.forEach((node) => {
                node.style.display = 'block';
            });
            this.refs.pgaTourWithoutExemptionPlaceholder.insertAdjacentElement('beforeEnd', this.refs.pgaTourSection);
            this.refs.pgaTourSelect.setAttribute('required', '');
        }
    }

    onPgaTourSelectChange() {
        const currentValue = [...this.refs.pgaTourSelect.options].filter((option) => option.selected).map((option) => option.value);
        if (currentValue.indexOf(this.pgaOtherValue) !== -1) {
            this.refs.pgaTourOther.style.display = 'block';
        } else {
            this.refs.pgaTourOther.style.display = 'none';
        }
    }

    onFinalVenuesChange(e) {
        const changedRadio = e.target;
        const sameValueRadios = this.refs.finalVenues.filter((radio) => radio !== changedRadio && (radio.value === changedRadio.value) && radio.checked);
        if (sameValueRadios.length > 0) {
            sameValueRadios.forEach((radio) => {
                radio.checked = false;
            });
        }
    }

    onRqCourseChange(e) {
        this.refs.rqCourseSelect.forEach((select) => {
            if (select === e.target) {
                return;
            }
            const target = e.target;
            const selectedValue = target.options[target.selectedIndex].value;

            for (let i = 0; i < select.options.length; i++) {
                if (select.options[i].value === selectedValue) {
                    select.options[i].setAttribute('disabled', 'disabled');
                } else if (select.options[i].value.toString !== '-1') {
                    select.options[i].removeAttribute('disabled');
                }
            }
        });
    }
}
